"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Regular12 = exports.Regular14 = exports.Regular16 = exports.Regular18 = exports.Caps10 = exports.Caps12 = exports.Caps14 = exports.Caps16 = exports.Caps18 = exports.Medium12 = exports.Medium14 = exports.Medium16 = exports.Medium18 = exports.Medium24 = exports.Bold12 = exports.Bold14 = exports.Bold16 = exports.Bold18 = exports.Bold22 = exports.Bold24 = exports.Bold32 = exports.Bold40 = void 0;

var _index = require("../typography/index.js");

// GENERATED FILE, PLEASE DO NOT EDIT
var Bold40 = {
  size: _index.Tokens.Sizes.S40,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: _index.Tokens.LetterSpacings.Tight,
  lineHeight: _index.Tokens.LineHeights.S40,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Bold40 = Bold40;
var Bold32 = {
  size: _index.Tokens.Sizes.S32,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: _index.Tokens.LetterSpacings.Tight,
  lineHeight: _index.Tokens.LineHeights.S32,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Bold32 = Bold32;
var Bold24 = {
  size: _index.Tokens.Sizes.S24,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: _index.Tokens.LetterSpacings.Tight,
  lineHeight: _index.Tokens.LineHeights.S24,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Bold24 = Bold24;
var Bold22 = {
  size: _index.Tokens.Sizes.S22,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: _index.Tokens.LetterSpacings.Tight,
  lineHeight: _index.Tokens.LineHeights.S22,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Bold22 = Bold22;
var Bold18 = {
  size: _index.Tokens.Sizes.S18,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: _index.Tokens.LetterSpacings.Tight,
  lineHeight: _index.Tokens.LineHeights.S18,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Bold18 = Bold18;
var Bold16 = {
  size: _index.Tokens.Sizes.S16,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: _index.Tokens.LetterSpacings.Tight,
  lineHeight: _index.Tokens.LineHeights.S16,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Bold16 = Bold16;
var Bold14 = {
  size: _index.Tokens.Sizes.S14,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: _index.Tokens.LetterSpacings.Tight,
  lineHeight: _index.Tokens.LineHeights.S14,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Bold14 = Bold14;
var Bold12 = {
  size: _index.Tokens.Sizes.S12,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: _index.Tokens.LetterSpacings.Tight,
  lineHeight: _index.Tokens.LineHeights.S12,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Bold12 = Bold12;
var Medium24 = {
  size: _index.Tokens.Sizes.S24,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S24,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Medium24 = Medium24;
var Medium18 = {
  size: _index.Tokens.Sizes.S18,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S18,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Medium18 = Medium18;
var Medium16 = {
  size: _index.Tokens.Sizes.S16,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S16,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Medium16 = Medium16;
var Medium14 = {
  size: _index.Tokens.Sizes.S14,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S14,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Medium14 = Medium14;
var Medium12 = {
  size: _index.Tokens.Sizes.S12,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S12,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Medium12 = Medium12;
var Caps18 = {
  size: _index.Tokens.Sizes.S18,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: _index.Tokens.LetterSpacings.Wide,
  lineHeight: _index.Tokens.LineHeights.S18,
  textTransform: _index.Tokens.TextTransforms.UpperCase
};
exports.Caps18 = Caps18;
var Caps16 = {
  size: _index.Tokens.Sizes.S16,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: _index.Tokens.LetterSpacings.Wide,
  lineHeight: _index.Tokens.LineHeights.S16,
  textTransform: _index.Tokens.TextTransforms.UpperCase
};
exports.Caps16 = Caps16;
var Caps14 = {
  size: _index.Tokens.Sizes.S14,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: _index.Tokens.LetterSpacings.Wide,
  lineHeight: _index.Tokens.LineHeights.S14,
  textTransform: _index.Tokens.TextTransforms.UpperCase
};
exports.Caps14 = Caps14;
var Caps12 = {
  size: _index.Tokens.Sizes.S12,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: _index.Tokens.LetterSpacings.Wide,
  lineHeight: _index.Tokens.LineHeights.S12,
  textTransform: _index.Tokens.TextTransforms.UpperCase
};
exports.Caps12 = Caps12;
var Caps10 = {
  size: _index.Tokens.Sizes.S10,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: _index.Tokens.LetterSpacings.Wide,
  lineHeight: _index.Tokens.LineHeights.S10,
  textTransform: _index.Tokens.TextTransforms.UpperCase
};
exports.Caps10 = Caps10;
var Regular18 = {
  size: _index.Tokens.Sizes.S18,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S18,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Regular18 = Regular18;
var Regular16 = {
  size: _index.Tokens.Sizes.S16,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S16,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Regular16 = Regular16;
var Regular14 = {
  size: _index.Tokens.Sizes.S14,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S14,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Regular14 = Regular14;
var Regular12 = {
  size: _index.Tokens.Sizes.S12,
  family: 'SansSerif',
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: _index.Tokens.LetterSpacings.Normal,
  lineHeight: _index.Tokens.LineHeights.S12,
  textTransform: _index.Tokens.TextTransforms.Normal
};
exports.Regular12 = Regular12;